import { render, staticRenderFns } from "./PhaseOrderComponent.vue?vue&type=template&id=31ce6b62"
import script from "./PhaseOrderComponent.vue?vue&type=script&lang=js"
export * from "./PhaseOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports